import { Div, Ref, Text } from "@tblabs/truffle";


export class InfoBox extends Div
{
    constructor(title: string, content: string | Ref<string>, theme: string = "#a87603")
    {
        super();

        this.Style(`padding: 16px; margin: 32px 0; text-align: left; border-left: 12px solid ${theme}`);

        this.Append(
            new Div().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme),
            new Text(content).Color("#ccc"),
        );
    }
}
